import { Component, inject } from '@angular/core';
import { ConfirmationDialogService } from '../../services/confirmation-dialog.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-dialog',
  imports: [DialogModule, ButtonModule, CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  private dialogService: ConfirmationDialogService = inject(ConfirmationDialogService);

  protected data = this.dialogService.dialogData;
  protected visible = this.dialogService.visible;

  onConfirm() {
    this.dialogService.confirm();
  }

  onCancel() {
    this.dialogService.cancel();
  }
}
